<template>
  <b-row class="uk-grid uk-width-1-1 uk-margin-remove">
    <b-col class="uk-grid uk-width-1-1 uk-text-center uk-padding-remove">
      <span class="home-title uk-padding-remove uk-margin-bottom"
        >Добро пожаловать в систему Мой Дом для Председателя!</span
      >
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CommonPagesGreeting'
}
</script>

<style scoped>
.home-title {
  color: #fff;
}
</style>
